import modular from 'modujs'
import * as modules from './modules'
import globals from './globals'
import { debounce } from './utils/tickers'
import { $html } from './utils/dom'
import { ENV, FONT, CUSTOM_EVENT, CSS_CLASS, VARS } from './config'
import { isFontLoadingAPIAvailable, loadFonts } from './utils/fonts'

const app = new modular({
    modules,
})

const setViewportSizes = () => {

    // Global window size
    VARS.window.width = window.innerWidth
    if (ENV.IS_DESKTOP) {
        VARS.window.height = window.innerHeight
    }

    // Document styles
    const documentStyles = document.documentElement.style

    // Viewport width
    const vw = document.body.clientWidth * 0.01
    documentStyles.setProperty('--vw', `${vw}px`)

    if(ENV.REDUCED_MOTION) {
        $html.classList.add(CSS_CLASS.REDUCED_MOTION)
    }

    // Return if browser supports vh, svh, dvh, & lvh
    if (
        'CSS' in window
        && 'supports' in window.CSS
        && window.CSS.supports('height: 100svh')
        && window.CSS.supports('height: 100dvh')
        && window.CSS.supports('height: 100lvh')
    ) {
        return
    }

    // Viewport height
    const height = window.innerHeight
    const svh = document.documentElement.clientHeight * 0.01
    documentStyles.setProperty('--svh', `${svh}px`)
    const dvh = height * 0.01
    documentStyles.setProperty('--dvh', `${dvh}px`)

    if (document.body) {
        const fixed = document.createElement('div')
        fixed.style.width = '1px'
        fixed.style.height = '100vh'
        fixed.style.position = 'fixed'
        fixed.style.left = '0'
        fixed.style.top = '0'
        fixed.style.bottom = '0'
        fixed.style.visibility = 'hidden'

        document.body.appendChild(fixed)

        var fixedHeight = fixed.clientHeight

        fixed.remove()

        const lvh = fixedHeight * 0.01

        documentStyles.setProperty('--lvh', `${lvh}px`)
    }
}

window.addEventListener('load', () => {
    const $style = document.getElementById('main-css')

    if ($style) {
        if ($style.isLoaded) {
            init()
        } else {
            $style.addEventListener('load', init)
        }
    } else {
        console.warn('The "main-css" stylesheet not found')
    }
})

function init() {
    globals()
    setViewportSizes()

    app.init(app)

    if(ENV.IS_TOUCH) {
        $html.classList.add(CSS_CLASS.TOUCH)
    }

    // Bind window resize event with default vars
    const resizeEndEvent = new CustomEvent(CUSTOM_EVENT.RESIZE_END)
    window.addEventListener('resize', debounce(() => {
        setViewportSizes()
        window.dispatchEvent(resizeEndEvent)
    }, 100, false))

    window.addEventListener('orientationchange', () => {
        setViewportSizes()
    })

    const loaderFonts = new Promise(resolve => {
        /**
         * Eagerly load the following fonts.
         */
        if (isFontLoadingAPIAvailable) {
            loadFonts(FONT.EAGER, ENV.IS_DEV).then((eagerFonts) => {
                // $html.classList.add(CSS_CLASS.FONTS_LOADED)

                // if (ENV.IS_DEV) {
                //     console.group('Eager fonts loaded!', eagerFonts.length, '/', document.fonts.size)
                //     console.group('State of eager fonts:')
                //     eagerFonts.forEach(font => console.log(font.family, font.style, font.weight, font.status))
                //     console.groupEnd()
                //     console.group('State of all fonts:')
                //     document.fonts.forEach(font => console.log(font.family, font.style, font.weight, font.status))
                //     console.groupEnd()
                // }
                resolve()
            })
        } else {
            resolve()
        }
    })

    const loaderAnimation = new Promise(resolve => {
        const duration = ENV.IS_DEV ? 1500 : 1500
        const delay = Math.max(0, duration - (new Date() - window.timestamp))

        setTimeout(resolve, delay)
    })

    Promise.all([loaderAnimation, loaderFonts]).then(() => {
        $html.classList.add(CSS_CLASS.LOADED)
        $html.classList.remove(CSS_CLASS.LOADING)

        // Loader otu duration
        const loaderOutDuration = 500
        setTimeout(() => {
            $html.classList.add(CSS_CLASS.READY)
        }, loaderOutDuration);
    })
}
